<div class="page-nav" id="mybets-nav" [ngClass]="{ 'my-bets-tabs': isMyBetsTabRedesignEnabled }">
    @if (isMyBetsTabRedesignEnabled) {
        <ds-segmented-control [fullWidth]="true" [activeOption]="getActiveOption()" (activeOptionChange)="onSelectionChange($event)">
            @for (tab of tabs; track tab; let i = $index) {
                <ds-segmented-option [name]="i" [title]="getTabTitle(tab)"> </ds-segmented-option>
            }
        </ds-segmented-control>
    } @else {
        <div class="sliding-menu-container" [msStopEventPropagation]="'touchmove touchend'">
            <div class="sliding-menu">
                @for (tab of tabs; track tab) {
                    <div class="col menu-item" (click)="onSelectTab(tab)">
                        <a class="menu-item-anchor" [ngClass]="{ selected: tab.selected }" [msAutomation]="getDataAtributteName(tab.typeFilter)">
                            {{ tabNames[tab.typeFilter] }}
                            @if (tab.count) {
                                <sup class="mybets-nav-counter">{{ tab.count }}</sup>
                            }
                        </a>
                    </div>
                }
            </div>
        </div>
    }
    <div class="clear"></div>
</div>
